import { formatDateShort } from "../components/Clinic/AdminPatients/clientSportDisplay";
import {
  groupsOverlap,
  isClubWide,
  membershipGroupIds,
  planGroupIds,
} from "./membershipGroupScope";
import { getEffectiveMembershipStatus } from "./membershipStatus";

export { getEffectiveMembershipStatus };

export function isMembershipCurrentlyActive(m) {
  if (!m) return false;
  return getEffectiveMembershipStatus(m) === "active";
}

export function isMembershipFrozenNow(m) {
  if (!m) return false;
  return getEffectiveMembershipStatus(m) === "frozen";
}

export function dayAfterDate(isoDate) {
  if (!isoDate) return null;
  const d = new Date(`${isoDate}T12:00:00`);
  if (Number.isNaN(d.getTime())) return null;
  d.setDate(d.getDate() + 1);
  return d.toISOString().slice(0, 10);
}

function overlappingActive(memberships, patientId, plan = null) {
  const rows = (memberships || []).filter(
    (m) => String(m.patient_id) === String(patientId),
  );
  const planGroups = planGroupIds(plan);
  return rows.filter(
    (m) =>
      isMembershipCurrentlyActive(m) &&
      groupsOverlap(membershipGroupIds(m), planGroups),
  );
}

/** Можно ли выдать новый абонемент клиенту (не продление). */
export function analyzeMembershipAssignBlock(memberships, patientId, plan = null) {
  const rows = (memberships || []).filter(
    (m) => String(m.patient_id) === String(patientId),
  );

  const pending = rows.find((m) => m.status === "pending");
  if (pending) {
    return {
      blocked: true,
      reason: "pending",
      message:
        "У клиента уже есть неоплаченный абонемент — сначала примите оплату.",
      pending,
    };
  }

  const frozen = rows.find((m) => m.status === "frozen" || isMembershipFrozenNow(m));
  if (frozen) {
    return {
      blocked: true,
      reason: "frozen",
      message: "Абонемент заморожен. Новый можно выдать после завершения текущего.",
      frozen,
    };
  }

  const activeList = overlappingActive(memberships, patientId, plan);
  const active = activeList[0] || null;
  if (active) {
    const canRenew = true;
    const renewalStartsAt = active.ends_at
      ? dayAfterDate(active.ends_at)
      : new Date().toISOString().slice(0, 10);
    const scopeHint = plan && !isClubWide(planGroupIds(plan)) ? " для этой группы" : "";
    return {
      blocked: true,
      reason: "active",
      message: active.ends_at
        ? `Действует «${active.plan?.name || "абонемент"}»${scopeHint} до ${formatDateShort(active.ends_at)}.`
        : `Действует «${active.plan?.name || "абонемент"}»${scopeHint}${active.visits_remaining != null ? ` · ${active.visits_remaining} зан.` : ""}.`,
      active,
      canRenew,
      renewalStartsAt,
      needsEndDate: !active.ends_at,
    };
  }

  return { blocked: false };
}

export function listCurrentMemberships(memberships, patientId) {
  return (memberships || []).filter(
    (m) =>
      String(m.patient_id) === String(patientId) &&
      (isMembershipCurrentlyActive(m) || isMembershipFrozenNow(m)),
  );
}
